import React from 'react';
import { useTranslation } from 'react-i18next';
import ButtonLoader from './ButtonLoader';
const AuthCommonButton = ({ isLoader, Title, isDisabled = false, onClick }) => {
  const { t } = useTranslation(['auth', 'common']);
  return (
    <>
      <button
        type="submit"
        disabled={isDisabled ? isDisabled : isLoader}
        onClick={onClick}
        className={`text-[#0B243F] text-lg font-semibold rounded-md px-5 leading-normal py-3 flex flex-col justify-center items-center w-full
          ${isDisabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-[#A7D760] hover:bg-[#97C05B] focus:bg-[#A7D760] active:bg-[#8DB158] hover:transition-all'}
          `}
      >
        {isLoader ? <ButtonLoader title={t('processing')} /> : Title || 'NA'}
      </button>
    </>
  );
};
export default AuthCommonButton;
